/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import PatientDisenrolledJournalEvent, {
  proIrcReasons,
  reasons
} from "parog-web/models/patient-disenrolled-journal-event";

import { action } from "@ember/object";
import { service } from "@ember/service";
import FormAction from "parog-web/components/forc/form-action";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type { ValidatorMap } from "ember-changeset/types";
import type { IntlService } from "ember-intl";
import tWithDefault from "parog-web/utils/t-with-default";
import styles from "./index.module.css";

export default class DisenrollmentForm extends CrudJournalEventBaseComponent {
  styles = styles;
  @service declare intl: IntlService;

  static fullComponentId = "disenrollment/form";

  static journalEventClass = PatientDisenrolledJournalEvent;

  get retrievedJournalEvent() {
    return this.args.patient.patientDisenrolledJournalEvent;
  }

  get formAction(): FormAction {
    return this.retrievedJournalEvent ? FormAction.Edit : FormAction.New;
  }

  get forcDisplayName() {
    return this.retrievedJournalEvent
      ? "Modifier les informations de désinscription du patient"
      : "Désinscrire le patient";
  }

  get submitDisenrollmentButtonTitle() {
    return this.retrievedJournalEvent ? "Sauvegarder" : "Désinscrire";
  }

  get reasonOptions() {
    if (this.args.patient.healthCentre.proIrc) {
      return reasons.concat(proIrcReasons);
    }
    return reasons;
  }

  get validations(): ValidatorMap {
    const validations = this.journalEventClass.validations(this.intl);
    if (this.retrievedJournalEvent) {
      validations["occurredAt"] = [
        validatePresence({
          presence: true,
          description: tWithDefault(
            this.intl,
            "validations.patient-disenrolled-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur par rapport à la date de désinscription précédente. Veuillez modifier la date",
          onOrBefore: this.retrievedJournalEvent.occurredAt
        })
      ];
    }
    return validations;
  }

  afterCompleted = () => {
    this.router.transitionTo("medics-web.protected.patients.patient.dashboard");
  };

  @action
  onCancelDisenrollment() {
    this.router.transitionTo(
      "medics-web.protected.patients.patient.administrative"
    );
  }
}
